export enum ButtonType {
  IS_PRIMARY = 'is-primary',
  IS_PRIMARY_OUTLINED = 'is-primary is-outlined',
  IS_PRIMARY_LIGHT = 'is-primary is-light',
  IS_LIGHT = 'is-light',
  IS_WARNING = 'is-warning',
  IS_DANGER = 'is-danger',
  IS_GHOST = 'is-ghost',
  IS_DANGER_GHOST = 'is-danger-ghost',
  IS_INFO = 'is-info',
  IS_SUCCESS = 'is-success',
  IS_SECONDARY = 'is-secondary'
}
